import React from 'react';
import { HQ } from '../sportConfig';
import './NotificationButton.css';

export default function NotificationButton({ matchUrl, teamId, teamName, leagueId, leagueName, day }) {
  if (!window.SPORTS_HQ_PUSH_ENABLED) return null;
  const params = new URLSearchParams({sport:HQ.sport,return:window.location.pathname+window.location.search});
  const floorball = (matchUrl || '').match(/\/match\/(\d+)/);
  const hockey = (matchUrl || '').match(/^hq:\/\/hockey\/([^/]+)\/([^/]+)/);
  if (floorball && HQ.sport === 'floorball') params.set('match',`floorball:innebandy:${floorball[1]}`);
  if (hockey && HQ.sport === 'hockey') params.set('match',`hockey:${hockey[1]}:${hockey[2]}`);
  if (teamId) {params.set('team',String(teamId));params.set('team_name',teamName || String(teamId));}
  if (leagueId && !teamId && !matchUrl) {params.set('league',String(leagueId));params.set('league_name',leagueName || String(leagueId));}
  if (day) params.set('day',day);
  const label = matchUrl ? 'Notiser för matchen' : teamId ? 'Notiser för laget' : leagueId ? 'Notiser för serien' : HQ.sport === 'hockey' ? 'Notiser för hockey' : 'Notiser för innebandy';
  return <a data-push-status className="hq-notification-action" href={'/notifications/?'+params} aria-label={label} title={label}>
    <span className="push-status-symbol" aria-hidden="true" /><span className="push-status-label" aria-hidden="true" /><span className="push-status-description" />
  </a>;
}
